<template>
  <div class="home-portal">
    <HeroSection />
    <SolutionSection />
    <HonorSection />
    <ProductSection />
    <OpenSourceSection />
    <WritingSection />
    <StorySection />
    <ContactSection />
  </div>
</template>

<script>
import HeroSection from "./components/HeroSection";
import SolutionSection from "./components/SolutionSection";
import HonorSection from "./components/HonorSection";
import ProductSection from "./components/ProductSection";
import OpenSourceSection from "./components/OpenSourceSection";
import WritingSection from "./components/WritingSection";
import StorySection from "./components/StorySection";
import ContactSection from "./components/ContactSection";

export default {
  name: "Home",
  components: {
    HeroSection,
    SolutionSection,
    HonorSection,
    ProductSection,
    OpenSourceSection,
    WritingSection,
    StorySection,
    ContactSection
  },
  metaInfo: {
    title: "穆雄雄 - 医疗信息化与自研产品",
    meta: [
      {
        name: "keywords",
        content:
          "穆雄雄,muxiongxiong,山东睿泽网络科技,慢病管理平台,长护险信息化,医保监管,智慧电梯,小鱼早晚安,雄雄的工具箱,88688.team"
      },
      {
        name: "description",
        content:
          "穆雄雄的个人网站。山西吕梁人，现在济南做医疗信息化——区域慢病管理、长护险经办与监管、互联网医院，同时自己写小程序和开源工具，在 CSDN 写了十年技术文章。这里有方案演示、产品、履历和联系方式。"
      }
    ]
  }
};
</script>

<style scoped>
.home-portal {
  background: var(--bg);
}
</style>
